module.exports = __webpack_public_path__ + "static/award9-69c7a68629147fda7d765c0a8dcd4316.png";